export default __webpack_public_path__ + "static/media/mx-step3.3e03ad0a.png";